.nsx-name-form{
  padding-top:calc(var(--spacer) * 2);
  --form-field-label-width: 140px
}
